import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface GetLinkInvestmentFreeRequest {
    paymentSingleAmount: number;
    paymentRecurringAmount: number;
    paymentRecurringInterval: string;
    fundModelTypeId: number;
    investmentEndDate: string;
    riskReduction: boolean;
}

type GetLinkInvestmentFreeResponse = string;

const getLinkInvestmentFreeUrl = buildEndpoint(['products', 'investmentfree', 'links']);

const getLinkInvestmentFreeApiCall = (body: GetLinkInvestmentFreeRequest) =>
    apifetch<GetLinkInvestmentFreeResponse, GetLinkInvestmentFreeRequest>(getLinkInvestmentFreeUrl, 'POST')(body);

export const useGetLinkInvestmentFree = (body: GetLinkInvestmentFreeRequest, enabled: boolean) => {
    const query = useQuery<GetLinkInvestmentFreeResponse>(['investmentfreelink', body], async () => {
        return getLinkInvestmentFreeApiCall(body);
    },
        { enabled: enabled }
    );

    return query;
};